import { Button, ButtonGroup } from '@blueprintjs/core';
import React, { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../../components';
import { AnalyticsContext, OrganisationContext } from '../../../../context';
import { useQuery } from '../../../../hooks';
import { DATASOURCE_QUERY_DOCUMENT_MANIFEST } from '../../../../queries';
import DocumentManifestGridView from './gridView';

const DocumentManifestReport = ({ insight, onExport }: any) => {
  const { t } = useTranslation();
  const organisation = useContext(OrganisationContext);
  const analytics = useContext(AnalyticsContext);
  const [view, setView] = useState<'detail' | 'summary'>('detail');

  const { loading, data, error } = useQuery(DATASOURCE_QUERY_DOCUMENT_MANIFEST, {
    selector: 'queryDocumentManifest.result',
    variables: {
      organisationKey: organisation.key,
      reportId: insight.id,
    },
  });

  const actions = useMemo(() => {
    if (insight.exportType) {
      return [
        {
          ...insight.exportButtonProps,
          onClick: () => {
            analytics.events.insights.exportViewClicked();
            return onExport();
          },
        },
      ];
    }
    return [];
  }, [insight, analytics, onExport]);

  if (loading) {
    return <div>{t('Loading...')}</div>;
  }

  if (error) {
    return <div>{t('Unknown Error Occurred')}</div>;
  }

  return (
    <div className="row h-100">
      <PageHeader noWrapper={false} actions={actions} />
      <div className="px-3 pb-2">
        <ButtonGroup>
          <Button
            active={view === 'detail'}
            onClick={() => setView('detail')}
            text={t('All Documents')}
          />
          <Button
            active={view === 'summary'}
            onClick={() => setView('summary')}
            text={t('Summary by Location')}
          />
        </ButtonGroup>
      </div>
      <div className="w-100">
        <DocumentManifestGridView rows={data || []} view={view} />
      </div>
    </div>
  );
};

export default DocumentManifestReport;
